import XVIZLiveLoader from './xviz_socket/xviz-live-loader';

export default class SocketInterface extends XVIZLiveLoader {
	constructor(config) {
		console.log(config);
		const protocol =
			config.secure || window.location.protocol === 'https:' ? 'wss' : 'ws';
		const options = {
			logGuid: 'mock',
			bufferLength: 50,
			serverConfig: {
				defaultLogLength: 300,
				serverUrl: `${protocol}://${config.url}:${config.port}`,
			},
			worker: true,
			maxConcurrency: 4,
			view: config.view,
			rate: config.rate,
		};
		super(options);
		this.binded_f = {};
	}

	registerEvent(key, f, pointer = null) {
		this.binded_f[key] = f.bind(pointer);
	}

	_onOpen = () => {
		if (this.binded_f.opened) this.binded_f.opened();
	};

	_onClosed = () => {
		super.connect();
		if (this.binded_f.closed) this.binded_f.closed();
	};

	send(message) {
		var ws = this.isOpen();
		if (ws != null) {
			ws.send(message);
		}
	}
}
